import { render, staticRenderFns } from "./reset-password-request.vue?vue&type=template&id=64b2aeb9&scoped=true"
import script from "./reset-password-request.vue?vue&type=script&lang=js"
export * from "./reset-password-request.vue?vue&type=script&lang=js"
import style0 from "./reset-password-request.vue?vue&type=style&index=0&id=64b2aeb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b2aeb9",
  null
  
)

export default component.exports